/**
 * Format a pipeline name into a human-readable label.
 * e.g. "ahoy_custom_pipeline" -> "Custom Pipeline", "Sales Pipeline" -> "Sales Pipeline"
 */
export function formatPipelineLabel(pipelineName: string): string {
  return pipelineName
    .replace(/^ahoy_/, '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}
